import { render, staticRenderFns } from "./resource-exposure-data.vue?vue&type=template&id=396ae888&scoped=true"
import script from "./resource-exposure-data.vue?vue&type=script&lang=js"
export * from "./resource-exposure-data.vue?vue&type=script&lang=js"
import style0 from "./resource-exposure-data.vue?vue&type=style&index=0&id=396ae888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396ae888",
  null
  
)

export default component.exports